module.exports = __webpack_public_path__ + "static/media/add-block-range.6120a52c.png";